import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-trombolisis`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/monitoring-trombolisis/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/monitoring-trombolisis", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-trombolisis/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/monitoring-trombolisis/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Schedule
async function getSchedule(id: number) {
  const response = await http
    .getData(`/monitoring-trombolisis/${id}/schedule`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Logs
async function addLog(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-trombolisis/${monitoringId}/log`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateLog(monitoringId: number, logId: number, data: any) {
  const response = await http
    .putData(`/monitoring-trombolisis/${monitoringId}/log/${logId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteLog(monitoringId: number, logId: number) {
  const response = await http
    .deleteData(`/monitoring-trombolisis/${monitoringId}/log/${logId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Outcome
async function setOutcome(id: number, data: any) {
  const response = await http
    .postData(`/monitoring-trombolisis/${id}/outcome`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// Signing
async function sign(id: number, data: { role: string; password: string }) {
  const response = await http
    .postData(`/monitoring-trombolisis/${id}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}/monitoring-trombolisis/${id}/pdf`,
    "_blank"
  );
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  getSchedule,
  addLog,
  updateLog,
  deleteLog,
  setOutcome,
  sign,
  printPdf,
};
